// extracted by mini-css-extract-plugin
module.exports = {"iconDropdown":"_3V280UvxPXzuiYIFQGx4RM"};